module.exports = __webpack_public_path__ + "static/media/map-en.cff79c5c.jpg";